module.exports = __webpack_public_path__ + "static/ps5-5983b85c6d1a36bb51b20a0453436c2f.webp";